import { useId } from 'react';
import FormField from 'fe-design-base/atoms/FormField';
import MaskedTextInput from 'fe-design-base/atoms/MaskedTextInput';
import { Field, useFormikContext } from 'formik';

const MaskedTextField = ({
  name,
  label,
  inputId,
  size,
  width,
  fullWidth,
  labelPosition,
  labelWidth,
  shrink,
  disabled,
  hasAsterisk,
  helperText,
  successText,
  ...selectProps
}) => {
  const fieldId = useId();
  const { touched, errors } = useFormikContext();
  const error = touched?.[name] && errors?.[name] && !disabled;

  return (
    <FormField
      name={name}
      inputId={inputId || fieldId}
      size={size}
      width={width}
      fullWidth={fullWidth}
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      shrink={shrink}
      disabled={disabled}
      uxElement={selectProps.uxElement}
      hasAsterisk={hasAsterisk}
      helperText={helperText}
      successText={successText}
    >
      <Field
        as={MaskedTextInput}
        name={name}
        label={label}
        id={inputId || fieldId}
        disabled={disabled}
        size={size}
        error={error}
        {...selectProps}
      />
    </FormField>
  );
};

export default MaskedTextField;
